import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";
import {
  apiPaymentStatus,
  apiSubscriptionStatus,
} from "../services/apiService";
import { FaRegCheckCircle } from "react-icons/fa";
import Button from "../components/Button";
import { LoadingSpinner } from "../components";

const PaymentStatus = () => {
  const { setNavigateToDashboard, checkAuth } = useStateContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState({});
  const [payment, setPayment] = useState({});
  const [subscription, setSubscription] = useState({});
  const hasFetched = useRef(false);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get("session_id");
  const isSubscription =
    searchParams.get("subscription") === "true" ? true : false;

  const navigate = useNavigate();

  useEffect(() => {
    setNavigateToDashboard(false);
    if (!hasFetched.current) {
      isSubscription ? getSubscriptionStatus() : getPaymentStatus();
      hasFetched.current = true;
    }
    // eslint-disable-next-line
  }, []);

  const getPaymentStatus = async () => {
    const response = await apiPaymentStatus(sessionId);
    if (response.hasError) {
      setError(response.error);
    } else {
      setPayment(response.data);
    }
    setIsLoading(false);
  };

  console.log(payment);

  const getSubscriptionStatus = async () => {
    const response = await apiSubscriptionStatus(sessionId);
    if (response.hasError) {
      setError(response.error);
    } else {
      setSubscription(response.data);
    }
    // ensure enough time passes to update account page
    setTimeout(() => {
      navigate("/account");
      setIsLoading(false);
    }, 500);
    clearTimeout();
  };

  const handleDone = () => {
    checkAuth();
    navigate("/dashboard");
  };

  return (
    <div className="w-screen">
      <LoadingSpinner isLoading={isLoading} />
      {!isLoading && (
        <>
          <div className="flex justify-center mt-5 p-10">
            <div className="grid md:max-w-[500px] justify-items-center border-2 border-gray-400 rounded-2xl px-5 py-10">
              <div className="">
                <FaRegCheckCircle className="text-7xl text-green-500" />
              </div>
              <div className="flex justify-center text-2xl mt-10">
                Payment Summary
              </div>
              <div className="grid grid-cols-2 gap-x-14 gap-y-3 text-xl mt-5 p-5">
                <div>Rent:</div>
                <div className="place-self-end">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(payment.rentPaid / 100)}
                </div>
                <div>Fees:</div>
                <div className="place-self-end">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(payment.feesPaid / 100)}
                </div>
                <div className="text-2xl text-green-500 mt-5">Total:</div>
                <div className="place-self-end text-2xl text-green-500 mt-5">
                  {Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(payment.amount / 100)}
                </div>
              </div>
            </div>
            {/* <div className="grid justify-items-center border-2 border-gray-400 rounded-2xl p-10">
              <div className="">
                <FaRegCheckCircle className="text-7xl text-green-500" />
              </div>
              <div className="text-3xl mt-5">
                {Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  maximumFractionDigits: 2,
                }).format(
                  isSubscription
                    ? subscription.amount / 100
                    : payment.amount / 100
                )}
              </div>
              <div className="text-3xl text-center mt-5">
                {isSubscription ? "Upgrade Complete!" : "Payment Complete!"}
              </div>
            </div> */}
          </div>
          <div className="flex justify-center">
            <Button
              background="bg-snappily-orange"
              text="text-white"
              opacity="bg-opacity-100"
              title="Done"
              height="h-10"
              width="w-24"
              borderColor="border-none"
              borderHover="hover:border-snappily-orange"
              customFunc={handleDone}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentStatus;
